import { useModals } from "react-easy-modals";
import CategoriesNavigationModal from "@/components/categories-navigation-modal";
import BaseApp from "@/modules/base-app";
import useListenToTargetClick from "@/modules/hooks/use-listen-to-target-click";

function CategoriesNavigation({ selector, ...props }) {
  const modals = useModals();

  const openModal = () => {
    modals.open(CategoriesNavigationModal, props);
  };

  const handleClick = (e) => {
    if (e) {
      e.preventDefault();
    }
    openModal();
  };

  useListenToTargetClick(selector, handleClick);

  return null;
}

const CategoriesNavigationModalApp = (props) => (
  <BaseApp>
    <CategoriesNavigation {...props} />
  </BaseApp>
);

export default CategoriesNavigationModalApp;
